import React, { ReactElement } from 'react';
import oauthLogoGithubSrc from '../assets/oauth-logo-github.svg';
import { ButtonProps } from './Common';
import OauthButton from './OauthButton';

const GithubButton = (props: ButtonProps): ReactElement => {
  return <OauthButton {...props} iconSrc={oauthLogoGithubSrc} />;
};

export default GithubButton;
